import script from "./StepPricing.vue?vue&type=script&setup=true&lang=js"
export * from "./StepPricing.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import AmountField from "@/components/neue/wizard/AmountField.vue";
import PillRadioGroup from "@/components/neue/wizard/PillRadioGroup.vue";
import ToggleRow from "@/components/neue/wizard/ToggleRow.vue";
import WizardButton from "@/components/neue/wizard/WizardButton.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { AmountField, PillRadioGroup, ToggleRow, WizardButton, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { AmountField, PillRadioGroup, ToggleRow, WizardButton, WizardSection }, script.__o.components);}